const collage = (n: number) => `/images/landing-v2/collage/collage-${String(n).padStart(2, '0')}.jpg`

/** Background photo grid behind the scattered polaroids (6x3). */
export const GRID_PHOTOS: string[] = Array.from({ length: 18 }, (_, i) => collage(i + 1))

export interface PolaroidPhoto {
  src: string
  left: number
  top: number
  /** vw used inside clamp(260px, Nvw, 720px) */
  widthVw: number
  aspectRatio: string
  rotateDeg: number
}

/** Scattered, rotated photos layered on top of the grid to form the hero collage. */
export const POLAROID_PHOTOS: PolaroidPhoto[] = [
  { src: collage(5), left: -6, top: -12, widthVw: 30, aspectRatio: '1568 / 980', rotateDeg: -5 },
  { src: collage(7), left: 18, top: -10, widthVw: 32, aspectRatio: '1758 / 1150', rotateDeg: 3 },
  { src: collage(10), left: 44, top: -13, widthVw: 30, aspectRatio: '1342 / 1086', rotateDeg: -2 },
  { src: collage(13), left: 68, top: -9, widthVw: 30, aspectRatio: '1416 / 968', rotateDeg: 5 },
  { src: collage(2), left: -7, top: 14, widthVw: 22, aspectRatio: '772 / 1136', rotateDeg: 6 },
  { src: collage(15), left: 10, top: 22, widthVw: 30, aspectRatio: '1550 / 890', rotateDeg: -4 },
  { src: collage(4), left: 36, top: 18, widthVw: 24, aspectRatio: '1016 / 1112', rotateDeg: 2 },
  { src: collage(8), left: 55, top: 20, widthVw: 30, aspectRatio: '1512 / 1152', rotateDeg: -6 },
  { src: collage(11), left: 80, top: 16, widthVw: 22, aspectRatio: '784 / 1018', rotateDeg: 4 },
  { src: collage(3), left: -8, top: 46, widthVw: 32, aspectRatio: '1610 / 1060', rotateDeg: 3 },
  { src: collage(12), left: 20, top: 52, widthVw: 30, aspectRatio: '1566 / 1002', rotateDeg: -3 },
  { src: collage(14), left: 48, top: 48, widthVw: 22, aspectRatio: '870 / 1120', rotateDeg: 5 },
  { src: collage(18), left: 66, top: 50, widthVw: 30, aspectRatio: '1576 / 1164', rotateDeg: -4 },
  { src: collage(10), left: 86, top: 44, widthVw: 26, aspectRatio: '1342 / 1086', rotateDeg: -5 },
  { src: collage(16), left: -5, top: 72, widthVw: 34, aspectRatio: '1702 / 1006', rotateDeg: 4 },
  { src: collage(17), left: 26, top: 78, widthVw: 26, aspectRatio: '932 / 896', rotateDeg: -5 },
  { src: collage(9), left: 46, top: 70, widthVw: 24, aspectRatio: '782 / 852', rotateDeg: 2 },
  { src: collage(5), left: 62, top: 76, widthVw: 32, aspectRatio: '1568 / 980', rotateDeg: 3 },
  { src: collage(7), left: 86, top: 78, widthVw: 28, aspectRatio: '1758 / 1150', rotateDeg: -3 },
  { src: collage(6), left: 28, top: 40, widthVw: 22, aspectRatio: '776 / 868', rotateDeg: -4 },
  { src: collage(1), left: 70, top: 34, widthVw: 30, aspectRatio: '1680 / 1050', rotateDeg: 3 },
]

export const VENUE_PHOTO_GATHERING = collage(5)
export const VENUE_PHOTO_CHICAGO = collage(7)
